import { Injectable } from '@angular/core';
import * as Comlink from 'comlink';
import { TimeCheckClass } from '../web-workers/timecheck.worker';
import { TelemetryService } from './telemetry.service';

@Injectable({
  providedIn: 'root',
})
export class TimeService {
  private clockSkewInMS = 0;
  userTimerClass?: Comlink.Remote<TimeCheckClass> | TimeCheckClass;

  constructor(private telemetry: TelemetryService) {}
  /**
   * To be called once to calculate the clock skew
   */
  async generateClockSkewFromServer() {
    if (!this.userTimerClass) {
      await this._setUpClockSkewWorker();
    }
    this.clockSkewInMS = await this.userTimerClass!.getSkew();
    this.telemetry.logBasicEvent('clock_skew_generated', {
      clockSkewInMS: this.clockSkewInMS,
    });
  }

  /**
   * To be called once to set up the clock skew worker
   */
  private async _setUpClockSkewWorker() {
    const worker = new Worker(new URL('../web-workers/timecheck.worker.ts', import.meta.url));
    const remoteTimeCheckWorker = Comlink.wrap<typeof TimeCheckClass>(worker);
    this.userTimerClass = await new remoteTimeCheckWorker();
  }

  /**
   * @returns the current date with the clock skew applied
   */
  public date(timestamp?: Date): Date {
    const time = timestamp ?? new Date();
    return new Date(time.getTime() - this.clockSkewInMS);
  }
}
